import React from "react";
import { ReactComponent as AccountSummaryBlue } from "../../../../../../app/assets/icons/Account-summary-darkblue.svg";
import { ReactComponent as AccountSummaryLightGray } from "../../../../../../app/assets/icons/Account-summary-lightgray.svg";
import { ReactComponent as ProfileInformationBlue } from "../../../../../../app/assets/icons/Profile-information-darkblue.svg";
import { ReactComponent as ProfileInformationLightGray } from "../../../../../../app/assets/icons/Profile-information-lightgrey.svg";
import { ReactComponent as LoginInformationBlue } from "../../../../../../app/assets/icons/Log-in-information-darkblue.svg";
import { ReactComponent as LoginInformationLightGray } from "../../../../../../app/assets/icons/Log-in-information-lightgray.svg";
import { ReactComponent as SubscriptionPlanBlue } from "../../../../../../app/assets/icons/Subscription-plans-and-payment-darkblue.svg";
import { ReactComponent as SubscriptionPlanLightGray } from "../../../../../../app/assets/icons/Subscription-plans-and-payment-lightgray.svg";

export const DashboardIcon = ({ active }) => (
   <>
      {active ? (
         <svg
            width="24"
            height="26"
            viewBox="0 0 24 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M20.5963 24.2068H3.40293C2.94693 24.2068 2.50961 24.0257 2.18718 23.7032C1.86474 23.3808 1.68359 22.9435 1.68359 22.4875V3.5748C1.68359 3.11881 1.86474 2.68149 2.18718 2.35905C2.50961 2.03661 2.94693 1.85547 3.40293 1.85547H20.5963C21.0523 1.85547 21.4896 2.03661 21.812 2.35905C22.1345 2.68149 22.3156 3.11881 22.3156 3.5748V22.4875C22.3156 22.9435 22.1345 23.3808 21.812 23.7032C21.4896 24.0257 21.0523 24.2068 20.5963 24.2068Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M6.8418 1.85547V24.2068"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.8594 7.87305H16.298"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.8594 11.6045H16.298"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.8594 15.335H16.298"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.8594 19.0664H16.298"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      ) : (
         <svg
            width="24"
            height="26"
            viewBox="0 0 24 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M20.5963 24.2068H3.40293C2.94693 24.2068 2.50961 24.0257 2.18718 23.7032C1.86474 23.3808 1.68359 22.9435 1.68359 22.4875V3.5748C1.68359 3.11881 1.86474 2.68149 2.18718 2.35905C2.50961 2.03661 2.94693 1.85547 3.40293 1.85547H20.5963C21.0523 1.85547 21.4896 2.03661 21.812 2.35905C22.1345 2.68149 22.3156 3.11881 22.3156 3.5748V22.4875C22.3156 22.9435 22.1345 23.3808 21.812 23.7032C21.4896 24.0257 21.0523 24.2068 20.5963 24.2068Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M6.8418 1.85547V24.2068"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.8594 7.87305H16.298"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.8594 11.6045H16.298"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.8594 15.335H16.298"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.8594 19.0664H16.298"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      )}
   </>
);

export const RelationshipIcon = ({ active }) => (
   <>
      {active ? (
         <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M4.13281 24.5585V20.125H8.56634"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M24.333 10.9131C24.8034 13.423 24.4272 16.018 23.2635 18.291C22.0997 20.5639 20.2143 22.3862 17.903 23.4719C15.5918 24.5576 12.9854 24.8452 10.493 24.2897C8.00064 23.7341 5.76321 22.3668 4.13184 20.4023"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M1.66802 15.1498C1.19762 12.64 1.5738 10.0449 2.73753 7.77197C3.90127 5.49899 5.7867 3.67668 8.09798 2.59099C10.4093 1.50531 13.0156 1.21768 15.508 1.77325C18.0004 2.32881 20.2378 3.69613 21.8692 5.66066"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M21.8671 1.50391V5.93744H17.4336"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M10.7656 9.90261C10.7656 10.4953 11.0011 11.0637 11.4201 11.4827C11.8392 11.9018 12.4076 12.1373 13.0003 12.1373C13.5929 12.1373 14.1613 11.9018 14.5804 11.4827C14.9995 11.0637 15.2349 10.4953 15.2349 9.90261C15.2349 9.30995 14.9995 8.74156 14.5804 8.32248C14.1613 7.9034 13.5929 7.66797 13.0003 7.66797C12.4076 7.66797 11.8392 7.9034 11.4201 8.32248C11.0011 8.74156 10.7656 9.30995 10.7656 9.90261Z"
               stroke="#252938"
               strokeWidth="2"
            />
            <path
               d="M8.90332 17.5009C9.25082 16.7031 9.82364 16.0242 10.5515 15.5473C11.2794 15.0704 12.1306 14.8164 13.0008 14.8164C13.8709 14.8164 14.7222 15.0704 15.45 15.5473C16.1779 16.0242 16.7507 16.7031 17.0982 17.5009"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
            />
         </svg>
      ) : (
         <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M4.13281 24.5585V20.125H8.56634"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M24.333 10.9131C24.8034 13.423 24.4272 16.018 23.2635 18.291C22.0997 20.5639 20.2143 22.3862 17.903 23.4719C15.5918 24.5576 12.9854 24.8452 10.493 24.2897C8.00064 23.7341 5.76321 22.3668 4.13184 20.4023"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M1.66802 15.1498C1.19762 12.64 1.5738 10.0449 2.73753 7.77197C3.90127 5.49899 5.7867 3.67668 8.09798 2.59099C10.4093 1.50531 13.0156 1.21768 15.508 1.77325C18.0004 2.32881 20.2378 3.69613 21.8692 5.66066"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M21.8671 1.50391V5.93744H17.4336"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M10.7656 9.90261C10.7656 10.4953 11.0011 11.0637 11.4201 11.4827C11.8392 11.9018 12.4076 12.1373 13.0003 12.1373C13.5929 12.1373 14.1613 11.9018 14.5804 11.4827C14.9995 11.0637 15.2349 10.4953 15.2349 9.90261C15.2349 9.30995 14.9995 8.74156 14.5804 8.32248C14.1613 7.9034 13.5929 7.66797 13.0003 7.66797C12.4076 7.66797 11.8392 7.9034 11.4201 8.32248C11.0011 8.74156 10.7656 9.30995 10.7656 9.90261Z"
               stroke="#D5D5D5"
               strokeWidth="2"
            />
            <path
               d="M8.90332 17.5009C9.25082 16.7031 9.82364 16.0242 10.5515 15.5473C11.2794 15.0704 12.1306 14.8164 13.0008 14.8164C13.8709 14.8164 14.7222 15.0704 15.45 15.5473C16.1779 16.0242 16.7507 16.7031 17.0982 17.5009"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
            />
         </svg>
      )}
   </>
);

export const BeneficiariesIcon = ({ active }) => (
   <>
      {active ? (
         <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M16.3428 4.67586C16.3428 5.56245 16.695 6.41271 17.3219 7.03962C17.9488 7.66653 18.7991 8.01872 19.6856 8.01872C20.5722 8.01872 21.4225 7.66653 22.0494 7.03962C22.6763 6.41271 23.0285 5.56245 23.0285 4.67586C23.0285 3.78928 22.6763 2.93902 22.0494 2.31211C21.4225 1.6852 20.5722 1.33301 19.6856 1.33301C18.7991 1.33301 17.9488 1.6852 17.3219 2.31211C16.695 2.93902 16.3428 3.78928 16.3428 4.67586Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M24.6996 16.3756V14.7042C24.6999 13.5923 24.3306 12.5118 23.6498 11.6326C22.969 10.7535 22.0153 10.1256 20.9386 9.84764C19.862 9.56971 18.7235 9.65753 17.7022 10.0973C16.681 10.537 15.8348 11.3038 15.2969 12.2769"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M2.97168 4.67586C2.97168 5.56245 3.32387 6.41271 3.95078 7.03962C4.57769 7.66653 5.42796 8.01872 6.31454 8.01872C7.20112 8.01872 8.05139 7.66653 8.67829 7.03962C9.3052 6.41271 9.65739 5.56245 9.65739 4.67586C9.65739 3.78928 9.3052 2.93902 8.67829 2.31211C8.05139 1.6852 7.20112 1.33301 6.31454 1.33301C5.42796 1.33301 4.57769 1.6852 3.95078 2.31211C3.32387 2.93902 2.97168 3.78928 2.97168 4.67586Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M1.2998 16.3756V14.7042C1.29949 13.5923 1.66877 12.5118 2.34958 11.6326C3.0304 10.7535 3.98412 10.1256 5.06075 9.84764C6.13739 9.56971 7.27587 9.65753 8.29715 10.0973C9.31844 10.537 10.1646 11.3038 10.7025 12.2769"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M9.65918 14.7003C9.65918 15.5869 10.0114 16.4371 10.6383 17.064C11.2652 17.6909 12.1155 18.0431 13.002 18.0431C13.8886 18.0431 14.7389 17.6909 15.3658 17.064C15.9927 16.4371 16.3449 15.5869 16.3449 14.7003C16.3449 13.8137 15.9927 12.9634 15.3658 12.3365C14.7389 11.7096 13.8886 11.3574 13.002 11.3574C12.1155 11.3574 11.2652 11.7096 10.6383 12.3365C10.0114 12.9634 9.65918 13.8137 9.65918 14.7003Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M18.0159 24.7291C18.0159 23.3993 17.4876 22.1239 16.5472 21.1835C15.6069 20.2431 14.3315 19.7148 13.0016 19.7148C11.6717 19.7148 10.3963 20.2431 9.45595 21.1835C8.51559 22.1239 7.9873 23.3993 7.9873 24.7291"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      ) : (
         <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M16.3428 4.67586C16.3428 5.56245 16.695 6.41271 17.3219 7.03962C17.9488 7.66653 18.7991 8.01872 19.6856 8.01872C20.5722 8.01872 21.4225 7.66653 22.0494 7.03962C22.6763 6.41271 23.0285 5.56245 23.0285 4.67586C23.0285 3.78928 22.6763 2.93902 22.0494 2.31211C21.4225 1.6852 20.5722 1.33301 19.6856 1.33301C18.7991 1.33301 17.9488 1.6852 17.3219 2.31211C16.695 2.93902 16.3428 3.78928 16.3428 4.67586Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M24.6996 16.3756V14.7042C24.6999 13.5923 24.3306 12.5118 23.6498 11.6326C22.969 10.7535 22.0153 10.1256 20.9386 9.84764C19.862 9.56971 18.7235 9.65753 17.7022 10.0973C16.681 10.537 15.8348 11.3038 15.2969 12.2769"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M2.97168 4.67586C2.97168 5.56245 3.32387 6.41271 3.95078 7.03962C4.57769 7.66653 5.42796 8.01872 6.31454 8.01872C7.20112 8.01872 8.05139 7.66653 8.67829 7.03962C9.3052 6.41271 9.65739 5.56245 9.65739 4.67586C9.65739 3.78928 9.3052 2.93902 8.67829 2.31211C8.05139 1.6852 7.20112 1.33301 6.31454 1.33301C5.42796 1.33301 4.57769 1.6852 3.95078 2.31211C3.32387 2.93902 2.97168 3.78928 2.97168 4.67586Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M1.2998 16.3756V14.7042C1.29949 13.5923 1.66877 12.5118 2.34958 11.6326C3.0304 10.7535 3.98412 10.1256 5.06075 9.84764C6.13739 9.56971 7.27587 9.65753 8.29715 10.0973C9.31844 10.537 10.1646 11.3038 10.7025 12.2769"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M9.65918 14.7003C9.65918 15.5869 10.0114 16.4371 10.6383 17.064C11.2652 17.6909 12.1155 18.0431 13.002 18.0431C13.8886 18.0431 14.7389 17.6909 15.3658 17.064C15.9927 16.4371 16.3449 15.5869 16.3449 14.7003C16.3449 13.8137 15.9927 12.9634 15.3658 12.3365C14.7389 11.7096 13.8886 11.3574 13.002 11.3574C12.1155 11.3574 11.2652 11.7096 10.6383 12.3365C10.0114 12.9634 9.65918 13.8137 9.65918 14.7003Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M18.0159 24.7291C18.0159 23.3993 17.4876 22.1239 16.5472 21.1835C15.6069 20.2431 14.3315 19.7148 13.0016 19.7148C11.6717 19.7148 10.3963 20.2431 9.45595 21.1835C8.51559 22.1239 7.9873 23.3993 7.9873 24.7291"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      )}
   </>
);

export const TargetsIcon = ({ active }) => (
   <>
      {active ? (
         <svg
            width="26"
            height="27"
            viewBox="0 0 26 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M23.953 13.9746C23.7874 16.0569 23.0275 18.0478 21.7635 19.7109C20.4995 21.3741 18.7849 22.6394 16.8229 23.3564C14.8611 24.0737 12.7345 24.2127 10.696 23.757C8.65747 23.3011 6.79263 22.2697 5.32302 20.7852C3.85342 19.3008 2.84082 17.4257 2.40554 15.3827C1.97026 13.3397 2.13058 11.2147 2.86747 9.2601C3.60437 7.30554 4.88685 5.60358 6.56255 4.35644C8.23825 3.10929 10.2367 2.36938 12.3206 2.22461"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M17.7609 14.9386C17.4577 15.7188 16.9649 16.4112 16.327 16.953C15.689 17.4949 14.9261 17.8692 14.1071 18.0421C13.2882 18.2149 12.439 18.181 11.6365 17.9433C10.834 17.7055 10.1034 17.2714 9.51076 16.6803C8.91816 16.0893 8.48221 15.3598 8.2424 14.5578C8.00256 13.7559 7.96641 12.9069 8.13718 12.0875C8.30798 11.2681 8.68032 10.5042 9.22053 9.86484C9.76075 9.2255 10.4518 8.73091 11.2312 8.42578"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M13.0762 13.1095L17.2726 8.91309"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M20.629 9.75182L17.2719 8.91253L16.4326 5.55539L19.7898 2.19824L20.629 5.55539L23.9862 6.39467L20.629 9.75182Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      ) : (
         <svg
            width="26"
            height="27"
            viewBox="0 0 26 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M23.953 13.9751C23.7874 16.0574 23.0275 18.0483 21.7635 19.7114C20.4995 21.3745 18.7849 22.6398 16.8229 23.3569C14.8611 24.0742 12.7345 24.2132 10.696 23.7574C8.65747 23.3015 6.79263 22.2702 5.32302 20.7857C3.85342 19.3013 2.84082 17.4262 2.40554 15.3832C1.97026 13.3402 2.13058 11.2152 2.86747 9.26059C3.60437 7.30603 4.88685 5.60407 6.56255 4.35693C8.23825 3.10978 10.2367 2.36987 12.3206 2.2251"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M17.7609 14.9382C17.4577 15.7184 16.9649 16.4107 16.327 16.9525C15.689 17.4944 14.9261 17.8687 14.1071 18.0416C13.2882 18.2145 12.439 18.1805 11.6365 17.9428C10.834 17.705 10.1034 17.2709 9.51076 16.6799C8.91816 16.0888 8.48221 15.3593 8.2424 14.5574C8.00256 13.7554 7.96641 12.9064 8.13718 12.087C8.30798 11.2676 8.68032 10.5037 9.22053 9.86435C9.76075 9.22501 10.4518 8.73042 11.2312 8.42529"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M13.0762 13.109L17.2726 8.9126"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M20.629 9.75182L17.2719 8.91253L16.4326 5.55539L19.7898 2.19824L20.629 5.55539L23.9862 6.39467L20.629 9.75182Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      )}
   </>
);

export const SurveyToolsIcon = ({ active }) => (
   <>
      {active ? (
         <svg
            width="21"
            height="26"
            viewBox="0 0 21 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M15.3417 3.25488H18.0133C18.4856 3.25488 18.9386 3.44253 19.2726 3.77654C19.6067 4.11055 19.7943 4.56357 19.7943 5.03594V22.8465C19.7943 23.3188 19.6067 23.7719 19.2726 24.1059C18.9386 24.4399 18.4856 24.6275 18.0133 24.6275H3.76482C3.29245 24.6275 2.83944 24.4399 2.50542 24.1059C2.17141 23.7719 1.98376 23.3188 1.98376 22.8465V5.03594C1.98376 4.56357 2.17141 4.11055 2.50542 3.77654C2.83944 3.44253 3.29245 3.25488 3.76482 3.25488H6.4364"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M13.5606 1.47363H8.21746C7.23381 1.47363 6.4364 2.27104 6.4364 3.25469V4.14521C6.4364 5.12886 7.23381 5.92627 8.21746 5.92627H13.5606C14.5443 5.92627 15.3417 5.12886 15.3417 4.14521V3.25469C15.3417 2.27104 14.5443 1.47363 13.5606 1.47363Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M6.4364 10.3789H15.3417"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M6.4364 14.8311H15.3417"
               stroke="#999999"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M6.4364 19.2842H15.3417"
               stroke="#999999"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      ) : (
         <svg
            width="20"
            height="26"
            viewBox="0 0 20 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M14.4526 3.23535H17.1242C17.5966 3.23535 18.0496 3.423 18.3836 3.75701C18.7176 4.09102 18.9053 4.54404 18.9053 5.01641V22.8269C18.9053 23.2993 18.7176 23.7523 18.3836 24.0863C18.0496 24.4204 17.5966 24.608 17.1242 24.608H2.87578C2.40342 24.608 1.9504 24.4204 1.61639 24.0863C1.28237 23.7523 1.09473 23.2993 1.09473 22.8269V5.01641C1.09473 4.54404 1.28237 4.09102 1.61639 3.75701C1.9504 3.423 2.40342 3.23535 2.87578 3.23535H5.54736"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.6711 1.4541H7.32793C6.34428 1.4541 5.54688 2.25151 5.54688 3.23516V4.12568C5.54688 5.10933 6.34428 5.90674 7.32793 5.90674H12.6711C13.6547 5.90674 14.4521 5.10933 14.4521 4.12568V3.23516C14.4521 2.25151 13.6547 1.4541 12.6711 1.4541Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M5.54688 10.3594H14.4521"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M5.54688 14.8115H14.4521"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M5.54688 19.2646H14.4521"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      )}
   </>
);

export const TasksIcon = ({ active }) => (
   <>
      {active ? (
         <svg
            width="26"
            height="26"
            viewBox="0 0 20 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M14.4526 3.23535H17.1242C17.5966 3.23535 18.0496 3.423 18.3836 3.75701C18.7176 4.09102 18.9053 4.54404 18.9053 5.01641V22.8269C18.9053 23.2993 18.7176 23.7523 18.3836 24.0863C18.0496 24.4204 17.5966 24.608 17.1242 24.608H2.87578C2.40342 24.608 1.9504 24.4204 1.61639 24.0863C1.28237 23.7523 1.09473 23.2993 1.09473 22.8269V5.01641C1.09473 4.54404 1.28237 4.09102 1.61639 3.75701C1.9504 3.423 2.40342 3.23535 2.87578 3.23535H5.54736"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.6711 1.4541H7.32793C6.34428 1.4541 5.54688 2.25151 5.54688 3.23516V4.12568C5.54688 5.10933 6.34428 5.90674 7.32793 5.90674H12.6711C13.6547 5.90674 14.4521 5.10933 14.4521 4.12568V3.23516C14.4521 2.25151 13.6547 1.4541 12.6711 1.4541Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M5.54688 10.3594H14.4521"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M5.54688 14.8115H14.4521"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M5.54688 19.2646H14.4521"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      ) : (
         <svg
            width="26"
            height="26"
            viewBox="0 0 20 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M14.4526 3.23535H17.1242C17.5966 3.23535 18.0496 3.423 18.3836 3.75701C18.7176 4.09102 18.9053 4.54404 18.9053 5.01641V22.8269C18.9053 23.2993 18.7176 23.7523 18.3836 24.0863C18.0496 24.4204 17.5966 24.608 17.1242 24.608H2.87578C2.40342 24.608 1.9504 24.4204 1.61639 24.0863C1.28237 23.7523 1.09473 23.2993 1.09473 22.8269V5.01641C1.09473 4.54404 1.28237 4.09102 1.61639 3.75701C1.9504 3.423 2.40342 3.23535 2.87578 3.23535H5.54736"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.6711 1.4541H7.32793C6.34428 1.4541 5.54688 2.25151 5.54688 3.23516V4.12568C5.54688 5.10933 6.34428 5.90674 7.32793 5.90674H12.6711C13.6547 5.90674 14.4521 5.10933 14.4521 4.12568V3.23516C14.4521 2.25151 13.6547 1.4541 12.6711 1.4541Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M5.54688 10.3594H14.4521"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M5.54688 14.8115H14.4521"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M5.54688 19.2646H14.4521"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      )}
   </>
);

export const MembersIcon = ({ active }) => (
   <>
      {active ? (
         <svg
            width="27"
            height="25"
            viewBox="0 0 27 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M9.9164 9.82035C12.1916 9.82035 14.0359 7.97598 14.0359 5.70083C14.0359 3.42567 12.1916 1.5813 9.9164 1.5813C7.64125 1.5813 5.79688 3.42567 5.79688 5.70083C5.79688 7.97598 7.64125 9.82035 9.9164 9.82035Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M18.1558 23.5521H1.67773V21.7212C1.67773 19.5361 2.54578 17.4405 4.0909 15.8953C5.63602 14.3502 7.73166 13.4822 9.91679 13.4822C12.1019 13.4822 14.1976 14.3502 15.7427 15.8953C17.2878 17.4405 18.1558 19.5361 18.1558 21.7212V23.5521Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M17.2402 1.5813C18.3328 1.5813 19.3806 2.01532 20.1532 2.78788C20.9257 3.56044 21.3598 4.60826 21.3598 5.70083C21.3598 6.79339 20.9257 7.84121 20.1532 8.61377C19.3806 9.38633 18.3328 9.82035 17.2402 9.82035"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M20.1699 13.8301C21.7295 14.4234 23.0723 15.4763 24.0204 16.8494C24.9685 18.2225 25.4773 19.8512 25.4795 21.5199V23.5522H22.7332"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      ) : (
         <svg
            width="26"
            height="25"
            viewBox="0 0 26 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M9.33828 9.28495C11.6134 9.28495 13.4578 7.44058 13.4578 5.16543C13.4578 2.89027 11.6134 1.0459 9.33828 1.0459C7.06312 1.0459 5.21875 2.89027 5.21875 5.16543C5.21875 7.44058 7.06312 9.28495 9.33828 9.28495Z"
               stroke="white"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M17.5777 23.0167H1.09961V21.1858C1.09961 19.0007 1.96765 16.9051 3.51277 15.3599C5.05789 13.8148 7.15353 12.9468 9.33866 12.9468C11.5238 12.9468 13.6194 13.8148 15.1646 15.3599C16.7097 16.9051 17.5777 19.0007 17.5777 21.1858V23.0167Z"
               stroke="white"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M16.6621 1.0459C17.7547 1.0459 18.8025 1.47992 19.5751 2.25248C20.3476 3.02504 20.7816 4.07286 20.7816 5.16543C20.7816 6.25799 20.3476 7.30581 19.5751 8.07837C18.8025 8.85093 17.7547 9.28495 16.6621 9.28495"
               stroke="white"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M19.5918 13.2944C21.1514 13.8877 22.4941 14.9406 23.4423 16.3138C24.3904 17.6869 24.8992 19.3156 24.9014 20.9842V23.0165H22.1551"
               stroke="white"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      )}
   </>
);

export const QuickActionsIcon = () => (
   <svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M10.1334 9.28398C12.4086 9.28398 14.253 7.4396 14.253 5.16445C14.253 2.8893 12.4086 1.04492 10.1334 1.04492C7.85829 1.04492 6.01392 2.8893 6.01392 5.16445C6.01392 7.4396 7.85829 9.28398 10.1334 9.28398Z"
         stroke="#D5D5D5"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
      <path
         d="M18.3725 23.0153H1.89441V21.1844C1.89441 18.9992 2.76245 16.9036 4.30757 15.3585C5.85269 13.8134 7.94833 12.9453 10.1335 12.9453C12.3186 12.9453 14.4142 13.8134 15.9594 15.3585C17.5045 16.9036 18.3725 18.9992 18.3725 21.1844V23.0153Z"
         stroke="#D5D5D5"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
      <path
         d="M17.457 1.04492C18.5496 1.04492 19.5974 1.47894 20.37 2.2515C21.1425 3.02406 21.5766 4.07188 21.5766 5.16445C21.5766 6.25702 21.1425 7.30483 20.37 8.07739C19.5974 8.84995 18.5496 9.28398 17.457 9.28398"
         stroke="#D5D5D5"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
      <path
         d="M20.3865 13.293C21.9461 13.8863 23.2888 14.9392 24.2369 16.3123C25.1851 17.6854 25.6939 19.3141 25.6961 20.9828V23.0151H22.9497"
         stroke="#D5D5D5"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
   </svg>
);

export const WorkspacesIcon = ({ active }) => (
   <>
      {active ? (
         <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M7.8333 1.42108H2.82625C1.90447 1.42108 1.15723 2.16833 1.15723 3.0901V8.09716C1.15723 9.01893 1.90447 9.76618 2.82625 9.76618H7.8333C8.75508 9.76618 9.50232 9.01893 9.50232 8.09716V3.0901C9.50232 2.16833 8.75508 1.42108 7.8333 1.42108Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M21.1858 1.42108H16.1788C15.257 1.42108 14.5098 2.16833 14.5098 3.0901V8.09716C14.5098 9.01893 15.257 9.76618 16.1788 9.76618H21.1858C22.1076 9.76618 22.8549 9.01893 22.8549 8.09716V3.0901C22.8549 2.16833 22.1076 1.42108 21.1858 1.42108Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M7.8333 14.7733H2.82625C1.90447 14.7733 1.15723 15.5205 1.15723 16.4423V21.4493C1.15723 22.3711 1.90447 23.1184 2.82625 23.1184H7.8333C8.75508 23.1184 9.50232 22.3711 9.50232 21.4493V16.4423C9.50232 15.5205 8.75508 14.7733 7.8333 14.7733Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M21.1858 14.7733H16.1788C15.257 14.7733 14.5098 15.5205 14.5098 16.4423V21.4493C14.5098 22.3711 15.257 23.1184 16.1788 23.1184H21.1858C22.1076 23.1184 22.8549 22.3711 22.8549 21.4493V16.4423C22.8549 15.5205 22.1076 14.7733 21.1858 14.7733Z"
               stroke="#404040"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      ) : (
         <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M8.40557 1.71802H3.39851C2.47674 1.71802 1.72949 2.46526 1.72949 3.38704V8.39409C1.72949 9.31587 2.47674 10.0631 3.39851 10.0631H8.40557C9.32734 10.0631 10.0746 9.31587 10.0746 8.39409V3.38704C10.0746 2.46526 9.32734 1.71802 8.40557 1.71802Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M21.7581 1.71802H16.7511C15.8293 1.71802 15.082 2.46526 15.082 3.38704V8.39409C15.082 9.31587 15.8293 10.0631 16.7511 10.0631H21.7581C22.6799 10.0631 23.4271 9.31587 23.4271 8.39409V3.38704C23.4271 2.46526 22.6799 1.71802 21.7581 1.71802Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M8.40557 15.0701H3.39851C2.47674 15.0701 1.72949 15.8173 1.72949 16.7391V21.7461C1.72949 22.6679 2.47674 23.4152 3.39851 23.4152H8.40557C9.32734 23.4152 10.0746 22.6679 10.0746 21.7461V16.7391C10.0746 15.8173 9.32734 15.0701 8.40557 15.0701Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M21.7581 15.0701H16.7511C15.8293 15.0701 15.082 15.8173 15.082 16.7391V21.7461C15.082 22.6679 15.8293 23.4152 16.7511 23.4152H21.7581C22.6799 23.4152 23.4271 22.6679 23.4271 21.7461V16.7391C23.4271 15.8173 22.6799 15.0701 21.7581 15.0701Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      )}
   </>
);

export const PaymentPlanIcon = () => (
   <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M24.0764 1.33398H3.81821C3.32978 1.33398 2.86135 1.52801 2.51597 1.87339C2.17059 2.21877 1.97656 2.6872 1.97656 3.17564V16.988C1.97656 17.4765 2.17059 17.9449 2.51597 18.2903C2.86135 18.6356 3.32978 18.8297 3.81821 18.8297H24.0764C24.5648 18.8297 25.0332 18.6356 25.3786 18.2903C25.724 17.9449 25.918 17.4765 25.918 16.988V3.17564C25.918 2.6872 25.724 2.21877 25.3786 1.87339C25.0332 1.52801 24.5648 1.33398 24.0764 1.33398Z"
         stroke="#D5D5D5"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
      <path
         d="M1.97656 7.77979H25.918"
         stroke="#D5D5D5"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
      <path
         d="M18.5518 14.2256H21.3142"
         stroke="#D5D5D5"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
   </svg>
);

export const OrganizationIcon = ({ active }) => (
   <>
      {active ? (
         <svg
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M13.2314 6.93783L14.1051 4.68231C14.2525 4.30043 14.5117 3.97195 14.8489 3.7399C15.1861 3.50785 15.5856 3.38305 15.9949 3.38184H17.6611C18.0705 3.38305 18.4699 3.50785 18.8071 3.7399C19.1443 3.97195 19.4035 4.30043 19.5509 4.68231L20.4246 6.93783L23.3914 8.64471L25.7891 8.27895C26.1884 8.22476 26.5947 8.29048 26.9565 8.46777C27.3184 8.64506 27.6193 8.92591 27.8211 9.27463L28.6339 10.697C28.8422 11.0513 28.9382 11.4604 28.9091 11.8703C28.8801 12.2803 28.7275 12.6718 28.4714 12.9932L26.988 14.8829V18.2967L28.512 20.1865C28.7681 20.5079 28.9207 20.8994 28.9498 21.3093C28.9788 21.7192 28.8828 22.1283 28.6746 22.4826L27.8618 23.905C27.6599 24.2537 27.359 24.5346 26.9972 24.7119C26.6354 24.8892 26.229 24.9549 25.8298 24.9007L23.432 24.5349L20.4653 26.2418L19.5915 28.4973C19.4442 28.8792 19.1849 29.2077 18.8477 29.4397C18.5105 29.6718 18.1111 29.7966 17.7018 29.7978H15.9949C15.5856 29.7966 15.1861 29.6718 14.8489 29.4397C14.5117 29.2077 14.2525 28.8792 14.1051 28.4973L13.2314 26.2418L10.2647 24.5349L7.8669 24.9007C7.46764 24.9549 7.06129 24.8892 6.69948 24.7119C6.33766 24.5346 6.03672 24.2537 5.8349 23.905L5.0221 22.4826C4.81382 22.1283 4.71786 21.7192 4.74689 21.3093C4.77591 20.8994 4.92855 20.5079 5.18466 20.1865L6.66802 18.2967V14.8829L5.14402 12.9932C4.88791 12.6718 4.73527 12.2803 4.70625 11.8703C4.67722 11.4604 4.77318 11.0513 4.98146 10.697L5.79426 9.27463C5.99608 8.92591 6.29702 8.64506 6.65884 8.46777C7.02065 8.29048 7.427 8.22476 7.82626 8.27895L10.224 8.64471L13.2314 6.93783ZM12.764 16.5898C12.764 17.3936 13.0024 18.1793 13.4489 18.8477C13.8955 19.516 14.5302 20.0369 15.2728 20.3445C16.0154 20.6521 16.8325 20.7325 17.6209 20.5757C18.4092 20.4189 19.1333 20.0319 19.7017 19.4635C20.27 18.8951 20.6571 18.171 20.8139 17.3827C20.9707 16.5943 20.8902 15.7772 20.5826 15.0346C20.2751 14.292 19.7542 13.6573 19.0858 13.2107C18.4175 12.7642 17.6318 12.5258 16.828 12.5258C15.7502 12.5258 14.7165 12.954 13.9543 13.7161C13.1922 14.4783 12.764 15.512 12.764 16.5898Z"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      ) : (
         <svg
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M12.9814 6.91464L13.8551 4.65912C14.0025 4.27724 14.2617 3.94876 14.5989 3.71671C14.9361 3.48465 15.3356 3.35985 15.7449 3.35864H17.4111C17.8205 3.35985 18.2199 3.48465 18.5571 3.71671C18.8943 3.94876 19.1535 4.27724 19.3009 4.65912L20.1746 6.91464L23.1414 8.62152L25.5391 8.25576C25.9384 8.20156 26.3447 8.26729 26.7065 8.44458C27.0684 8.62187 27.3693 8.90271 27.5711 9.25144L28.3839 10.6738C28.5922 11.0281 28.6882 11.4372 28.6591 11.8472C28.6301 12.2571 28.4775 12.6486 28.2214 12.97L26.738 14.8598V18.2735L28.262 20.1633C28.5181 20.4847 28.6707 20.8762 28.6998 21.2861C28.7288 21.696 28.6328 22.1051 28.4246 22.4594L27.6118 23.8818C27.4099 24.2305 27.109 24.5114 26.7472 24.6887C26.3854 24.866 25.979 24.9317 25.5798 24.8775L23.182 24.5117L20.2153 26.2186L19.3415 28.4741C19.1942 28.856 18.9349 29.1845 18.5977 29.4166C18.2605 29.6486 17.8611 29.7734 17.4518 29.7746H15.7449C15.3356 29.7734 14.9361 29.6486 14.5989 29.4166C14.2617 29.1845 14.0025 28.856 13.8551 28.4741L12.9814 26.2186L10.0147 24.5117L7.6169 24.8775C7.21764 24.9317 6.81129 24.866 6.44948 24.6887C6.08766 24.5114 5.78672 24.2305 5.5849 23.8818L4.7721 22.4594C4.56382 22.1051 4.46786 21.696 4.49689 21.2861C4.52591 20.8762 4.67855 20.4847 4.93466 20.1633L6.41802 18.2735V14.8598L4.89402 12.97C4.63791 12.6486 4.48527 12.2571 4.45625 11.8472C4.42722 11.4372 4.52318 11.0281 4.73146 10.6738L5.54426 9.25144C5.74608 8.90271 6.04702 8.62187 6.40884 8.44458C6.77065 8.26729 7.177 8.20156 7.57626 8.25576L9.97401 8.62152L12.9814 6.91464ZM12.514 16.5666C12.514 17.3704 12.7524 18.1561 13.1989 18.8245C13.6455 19.4928 14.2802 20.0137 15.0228 20.3213C15.7654 20.6289 16.5825 20.7093 17.3709 20.5525C18.1592 20.3957 18.8833 20.0087 19.4517 19.4403C20.02 18.8719 20.4071 18.1478 20.5639 17.3595C20.7207 16.5711 20.6402 15.754 20.3326 15.0114C20.0251 14.2688 19.5042 13.6341 18.8358 13.1875C18.1675 12.741 17.3818 12.5026 16.578 12.5026C15.5002 12.5026 14.4665 12.9308 13.7043 13.6929C12.9422 14.4551 12.514 15.4888 12.514 16.5666Z"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      )}
   </>
);

export const SurveyTools1Icon = ({ active }) => (
   <>
      {active ? (
         <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
         >
            <g clipPath="url(#clip0_2125_5093)">
               <path
                  d="M17.6424 3.20996H20.4282C20.9207 3.20996 21.3931 3.3981 21.7413 3.73298C22.0896 4.06787 22.2853 4.52207 22.2853 4.99568V22.8528C22.2853 23.3264 22.0896 23.7807 21.7413 24.1155C21.3931 24.4503 20.9207 24.6385 20.4282 24.6385H5.57101C5.07846 24.6385 4.60609 24.4503 4.25781 24.1155C3.90954 23.7807 3.71387 23.3264 3.71387 22.8528V4.99568C3.71387 4.52207 3.90954 4.06787 4.25781 3.73298C4.60609 3.3981 5.07846 3.20996 5.57101 3.20996H8.35672"
                  stroke="#252938"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M15.785 1.42432H10.2136C9.18793 1.42432 8.35645 2.22381 8.35645 3.21003V4.10289C8.35645 5.0891 9.18793 5.8886 10.2136 5.8886H15.785C16.8107 5.8886 17.6422 5.0891 17.6422 4.10289V3.21003C17.6422 2.22381 16.8107 1.42432 15.785 1.42432Z"
                  stroke="#252938"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M7.51367 11.6086C7.51367 12.8414 8.553 13.8408 9.8351 13.8408C10.1592 13.8408 10.4678 13.7769 10.748 13.6615C11.5763 13.3206 12.1565 12.5298 12.1565 11.6086C12.1565 10.3758 11.1172 9.37646 9.8351 9.37646C8.553 9.37646 7.51367 10.3758 7.51367 11.6086Z"
                  stroke="#252938"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M13.8389 16.3042L18.4817 20.7686"
                  stroke="#252938"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M18.4856 16.3042L13.8428 20.7686"
                  stroke="#252938"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </g>
            <defs>
               <clipPath id="clip0_2125_5093">
                  <rect width="26" height="25" fill="white" transform="translate(0 0.53125)" />
               </clipPath>
            </defs>
         </svg>
      ) : (
         <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
         >
            <g clipPath="url(#clip0_2125_5093)">
               <path
                  d="M17.6424 3.20996H20.4282C20.9207 3.20996 21.3931 3.3981 21.7413 3.73298C22.0896 4.06787 22.2853 4.52207 22.2853 4.99568V22.8528C22.2853 23.3264 22.0896 23.7807 21.7413 24.1155C21.3931 24.4503 20.9207 24.6385 20.4282 24.6385H5.57101C5.07846 24.6385 4.60609 24.4503 4.25781 24.1155C3.90954 23.7807 3.71387 23.3264 3.71387 22.8528V4.99568C3.71387 4.52207 3.90954 4.06787 4.25781 3.73298C4.60609 3.3981 5.07846 3.20996 5.57101 3.20996H8.35672"
                  stroke="#D5D5D5"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M15.785 1.42432H10.2136C9.18793 1.42432 8.35645 2.22381 8.35645 3.21003V4.10289C8.35645 5.0891 9.18793 5.8886 10.2136 5.8886H15.785C16.8107 5.8886 17.6422 5.0891 17.6422 4.10289V3.21003C17.6422 2.22381 16.8107 1.42432 15.785 1.42432Z"
                  stroke="#D5D5D5"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M7.51367 11.6086C7.51367 12.8414 8.553 13.8408 9.8351 13.8408C10.1592 13.8408 10.4678 13.7769 10.748 13.6615C11.5763 13.3206 12.1565 12.5298 12.1565 11.6086C12.1565 10.3758 11.1172 9.37646 9.8351 9.37646C8.553 9.37646 7.51367 10.3758 7.51367 11.6086Z"
                  stroke="#D5D5D5"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M13.8389 16.3042L18.4817 20.7686"
                  stroke="#D5D5D5"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M18.4856 16.3042L13.8428 20.7686"
                  stroke="#D5D5D5"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </g>
            <defs>
               <clipPath id="clip0_2125_5093">
                  <rect width="26" height="25" fill="white" transform="translate(0 0.53125)" />
               </clipPath>
            </defs>
         </svg>
      )}
   </>
);

export const SurveyData1Icon = ({ active }) => (
   <>
      {active ? (
         <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
         >
            <path
               d="M1 21.0312H21"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M7.15385 21.0313V1.03125H1V21.0313"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M13.3081 21.0314V10.2622H7.1543V21.0314"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M19.4615 21.0311V5.64648H13.3076V21.0311"
               stroke="#252938"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      ) : (
         <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
         >
            <path
               d="M1 21.0312H21"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M7.15385 21.0313V1.03125H1V21.0313"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M13.3081 21.0314V10.2622H7.1543V21.0314"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M19.4615 21.0311V5.64648H13.3076V21.0311"
               stroke="#D5D5D5"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      )}
   </>
);

export const AccountSummaryIcon = ({ active }) => {
   return <>{active ? <AccountSummaryBlue /> : <AccountSummaryLightGray />}</>;
};

export const ProfileInformationIcon = ({ active }) => {
   return <>{active ? <ProfileInformationBlue /> : <ProfileInformationLightGray />}</>;
};

export const LoginInformationIcon = ({ active }) => {
   return <>{active ? <LoginInformationBlue /> : <LoginInformationLightGray />}</>;
};

export const SubscriptionPlanIcon = ({ active }) => {
   return <>{active ? <SubscriptionPlanBlue /> : <SubscriptionPlanLightGray />}</>;
};

export const DeleteIcon = ({ active }) => (
   <>
      {active ? (
         <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
         >
            <g clipPath="url(#clip0_740_635)">
               <path
                  d="M0.857178 4.4541H11.1429"
                  stroke="#252938"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M2.14288 4.4541H9.85717V12.6359C9.85717 12.877 9.76686 13.1083 9.60612 13.2787C9.44537 13.4492 9.22736 13.545 9.00003 13.545H3.00003C2.7727 13.545 2.55468 13.4492 2.39393 13.2787C2.23319 13.1083 2.14288 12.877 2.14288 12.6359V4.4541Z"
                  stroke="#252938"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M3.85718 4.45481V4.00027C3.85718 3.3975 4.08294 2.81942 4.48481 2.39321C4.88667 1.96699 5.43171 1.72754 6.00003 1.72754C6.56836 1.72754 7.1134 1.96699 7.51526 2.39321C7.91713 2.81942 8.14289 3.3975 8.14289 4.00027V4.45481"
                  stroke="#252938"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M4.71429 6.27344V11.2734"
                  stroke="#252938"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M7.28577 6.27344V11.2734"
                  stroke="#252938"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </g>
            <defs>
               <clipPath id="clip0_740_635">
                  <rect width="12" height="14" fill="white" />
               </clipPath>
            </defs>
         </svg>
      ) : (
         <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
         >
            <g clipPath="url(#clip0_740_635)">
               <path
                  d="M0.857178 4.4541H11.1429"
                  stroke="#D5D5D5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M2.14288 4.4541H9.85717V12.6359C9.85717 12.877 9.76686 13.1083 9.60612 13.2787C9.44537 13.4492 9.22736 13.545 9.00003 13.545H3.00003C2.7727 13.545 2.55468 13.4492 2.39393 13.2787C2.23319 13.1083 2.14288 12.877 2.14288 12.6359V4.4541Z"
                  stroke="#D5D5D5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M3.85718 4.45481V4.00027C3.85718 3.3975 4.08294 2.81942 4.48481 2.39321C4.88667 1.96699 5.43171 1.72754 6.00003 1.72754C6.56836 1.72754 7.1134 1.96699 7.51526 2.39321C7.91713 2.81942 8.14289 3.3975 8.14289 4.00027V4.45481"
                  stroke="#D5D5D5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M4.71429 6.27344V11.2734"
                  stroke="#D5D5D5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M7.28577 6.27344V11.2734"
                  stroke="#D5D5D5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </g>
            <defs>
               <clipPath id="clip0_740_635">
                  <rect width="12" height="14" fill="white" />
               </clipPath>
            </defs>
         </svg>
      )}
   </>
);
